import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { Plus, User } from 'lucide-react';
import Section from '@/components/Section';
import { Button } from '@/components/ui/button';
import useContacts from '@/hooks/useContacts';
import { IContact } from '@/types';
import DataTable from '../DataTable/DataTable';
import Phone from '../Phone';
import Time from '../Time';

const Contacts = () => {
  const contacts = useContacts();
  const addContactModal = useModal('contact-form-drawer');
  const showContactDrawer = useModal('show-contact-drawer');
  const data = useMemo(() => contacts.data || [], [contacts.data]);

  const columns: ColumnDef<IContact>[] = useMemo(
    () => [
      {
        accessorKey: 'first_name',
        header: 'Contact',
        cell: ({ row }) => {
          return (
            <>
              <Button
                variant={'outline'}
                className="py-1.5 rounded-full px-2 text-sm cursor-pointer"
                onClick={() => {
                  showContactDrawer.show({ contactId: row.original.id });
                }}
              >
                <div className="flex items-center gap-1">
                  <User />
                  {row.original.name}
                </div>
              </Button>
            </>
          );
        },
      },
      {
        accessorKey: 'total_calls',
        header: 'Calls',
        cell: ({ row }) => {
          row.original.total_calls;
        },
      },
      {
        accessorKey: 'phone',
        header: 'Phone',
        cell: ({ row }) => <Phone>{row.original.phone}</Phone>,
      },
      {
        accessorKey: 'email',
        header: 'Email',
      },
      {
        accessorKey: 'created_at',
        header: 'Created',
        cell: ({ row }) => <Time>{row.original.created_at}</Time>,
      },
      {
        accessorKey: 'created_at',
        header: 'Updated',
        cell: ({ row }) => <Time>{row.original.updated_at}</Time>,
      },
    ],
    [],
  );

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-8 -mt-16">
        <Button className="ml-auto" onClick={() => addContactModal.show()}>
          <Plus />
          Add Contact
        </Button>
      </div>

      <Section>
        <DataTable data={data} columns={columns} model={contacts} />
      </Section>
    </div>
  );
};

export default Contacts;
